var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "kwt-checkbox"
  }, [_c('div', {
    staticClass: "outer-circle"
  }, [_c('div', {
    staticClass: "inner-circle",
    class: _vm.getValidationClass(_vm.isChecked, _vm.hasError)
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }